"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForgotPasswordCtrl = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const services_1 = require("../../services");
const user_service_1 = require("../../services/user.service");
class ForgotPasswordCtrl {
    constructor() {
        this.loading = false;
        this.completedReset = false;
    }
    requestPasswordReset(emailAddress) {
        this.setLoading(true);
        const normalizedEmailAddress = emailAddress.trim().toLowerCase();
        return user_service_1.UserMutator.requestPasswordReset(normalizedEmailAddress)
            .then(() => {
            this.setLoading(false);
            this.setCompletedReset(true);
        })
            .catch(e => {
            services_1.Logger.error(e);
            this.setLoading(false);
        });
    }
    isValidEmail(value) {
        if (typeof (value) !== 'string') {
            return false;
        }
        const emailAddress = value.trim();
        const firstIndex = emailAddress.indexOf('@');
        const lastIndex = emailAddress.lastIndexOf('@');
        return firstIndex > 0 &&
            firstIndex === lastIndex &&
            lastIndex < emailAddress.length - 1;
    }
    setLoading(loading) {
        this.loading = loading;
    }
    setCompletedReset(completed) {
        this.completedReset = completed;
    }
}
exports.ForgotPasswordCtrl = ForgotPasswordCtrl;
tslib_1.__decorate([
    mobx_1.observable
], ForgotPasswordCtrl.prototype, "loading", void 0);
tslib_1.__decorate([
    mobx_1.observable
], ForgotPasswordCtrl.prototype, "completedReset", void 0);
tslib_1.__decorate([
    mobx_1.action
], ForgotPasswordCtrl.prototype, "setLoading", null);
tslib_1.__decorate([
    mobx_1.action
], ForgotPasswordCtrl.prototype, "setCompletedReset", null);
//# sourceMappingURL=forgot.password.ctrl.js.map